import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/hooks/useTheme";
import { AuthProvider } from "@/hooks/useAuth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ImpersonationBanner } from "@/components/ImpersonationBanner";
import { SessionTimeoutWrapper } from "@/components/SessionTimeoutWrapper";
import Index from "./pages/Index";
import Kiosk from "./pages/Kiosk";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import History from "./pages/History";
import Scan from "./pages/Scan";
import Unsubscribe from "./pages/Unsubscribe";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => {
  // Check for kiosk mode URL parameter
  const isKioskMode = typeof window !== 'undefined' && 
    new URLSearchParams(window.location.search).get('kiosk') === 'true';

  return (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <ThemeProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <ImpersonationBanner />
          <SessionTimeoutWrapper />
          <BrowserRouter>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route 
                path="/" 
                element={
                  <ProtectedRoute checkEditorAccess>
                    {isKioskMode ? <Kiosk /> : <Index />}
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/kiosk" 
                element={
                  <ProtectedRoute requiredPermission="use_kiosk">
                    <Kiosk />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute requireAdmin>
                    <Admin />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/history" 
                element={
                  <ProtectedRoute>
                    <History />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/scan" 
                element={
                  <ProtectedRoute requiredPermission="use_mobile_scan">
                    <Scan />
                  </ProtectedRoute>
                } 
              />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </ThemeProvider>
    </AuthProvider>
  </QueryClientProvider>
  );
};

export default App;
